import React from 'react';
import PropTypes from 'prop-types';
import { ToastContext, Modal, Button, Message, CheckboxLabel, TooltipHelp } from '@weezevent/nacre';
import * as Sentry from '@sentry/browser';

import { useTranslation } from 'react-i18next';
import { useForm } from '../../../utils/validators';
import { useNotifications, triggerToast } from '../../../components/notifications/notificationsProvider';
import Style from './rotateBarcodePostAction.module.css';

export default function RotateBarcodePostAction({ actionInstance = null, onClose = () => {} }) {
    const { t } = useTranslation();
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const toast = React.useContext(ToastContext);
    const { addNotification } = useNotifications();
    const [form, setForm] = useForm({
        send_mail: false
        // to_reservation: false
    });

    const data = React.useMemo(() => {
        let _data = {
            send_mail: form.send_mail,
            to_reservation: form.to_reservation,
            items: actionInstance.mode === 'attendees' ? actionInstance.filtered_attendees : actionInstance.filtered_orders,
            mode: actionInstance.mode
        };
        return _data;
    }, [form, actionInstance]);

    const handleSubmit = React.useCallback(() => {
        setIsSubmitting(true);
        actionInstance
            .runPostAction(data)
            .then(response => {
                triggerToast(data.mode, actionInstance, data.items.length, response, t, toast, addNotification);
                setIsSubmitting(false);
                onClose();
            })
            .catch(e => {
                console.error(e);
                Sentry.captureException(e);
                toast.error(t(`ticket.manager.${data.mode}.action.` + actionInstance.constructor.NAME + '.toast.error', { count: data.items.length }));
                setIsSubmitting(false);
            });
    }, [actionInstance, onClose, data, addNotification]);

    const _onClose = React.useCallback(() => {
        onClose();
        setIsSubmitting(false);
    }, [onClose]);

    return (
        <Modal
            size="medium"
            open={Boolean(actionInstance)}
            onClose={_onClose}
            title={actionInstance ? t('ticket.manager.' + data.mode + '.action.' + actionInstance.constructor.NAME + '.title', { count: data.items.length }) : ''}
            subtitle={actionInstance ? t('ticket.manager.' + data.mode + '.action.' + actionInstance.constructor.NAME + '.subtitle', { count: data.items.length }) : ''}
            submitButton={<Button primary onClick={handleSubmit} disabled={isSubmitting} isLoading={isSubmitting} label={t('ticket.common.action.confirm')} />}
            cancelButton={<Button onClick={_onClose} label={t(`ticket.common.action.cancel`)} />}
        >
            <Message className={Style['warning_message']} type="warning" title={t('ticket.common.warning')}>
                {t('ticket.modal.irreversible')}
            </Message>
            <div>
                <div className={Style['info-text']}>{t('ticket.manager.attendees.action.rotate_barcode.info-text')}</div>
                <div className={Style['checkbox-and-tooltip']}>
                    <CheckboxLabel
                        label={t('ticket.manager.attendees.action.rotate_barcode.checkbox-action1')}
                        onChange={(e, { checked }) => setForm('send_mail', checked)}
                        checked={form.send_mail}
                    />
                    <TooltipHelp triggerOnHover position="bottom" title={t('ticket.manager.attendees.action.rotate_barcode.tooltip')} />
                </div>
                {/* <CheckboxLabel
                    label={t('ticket.manager.attendees.action.rotate_barcode.checkbox-action2')}
                    onChange={(e, { checked }) => setForm('to_reservation', checked)}
                    checked={ form.to_reservation }
                /> */}
            </div>
        </Modal>
    );
}

RotateBarcodePostAction.propTypes = {
    actionInstance: PropTypes.object,
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
    bodyContent: PropTypes.node
};
